import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { DavidN_Video1 } from '../../../../../utils/EN/Modals/aiArtists';

const ModalVideoDavidN1 = () => {
  return (
    <>
      <ModalVideo
        id="david-n-video-1"
        dataText={DavidN_Video1}
        videoSrc="https://www.youtube.com/embed/Dx1r8nH2Ie0?si=qSLMHoM-UOpvS2zl"
        videoTitle="KUTER_STUDIO_AI_DAVID_N_VIDEO_1"
      />
    </>
  );
};

export default ModalVideoDavidN1;
